// action names
export const SAVE_LANE_INFO       = 'savelaneoilconditions'
export const SAVE_EVENT_INFO      = 'saveeventinfo'
export const SAVE_EVENT_DETAILS   = 'saveeventdetails'
export const SAVE_LANE_CONDITIONS = 'saveeventlaneconditions'
export const SAVE_EVENT_SETUP     = 'saveeventsetup'
export const SAVE_EVENT_SCHOOLS   = 'saveeventprep'
export const FETCH_CENTER         = 'fetchcenter'
export const FETCH_TOURNAMENTS    = 'fetchtournaments'
export const FETCH_TOURNAMENT     = 'fetchtournament'
export const FETCH_MEMBER         = 'member'
export const FETCH_SCHOOL         = 'fetchschool'
export const FETCH_SCHOOL_INFO         = 'fetchschoolinfo'
export const FETCH_NONMEMBER_SCHOOL_DETAILS = 'fetchnonmemberschooldetails'
export const FETCH_NONMEMBER_SCHOOLS        = 'fetchnonmemberschools'
export const SAVE_PARTICIPANT_INFO          = 'saveparticipantinfo'
// search criteria constants
export const SEARCH_BY_NAME       = 'searchbyname'
export const SEARCH_BY_NUMBER     = 'searchbynumber'
// participants
export const SORT_ASCENDING  = 'sortascending'
export const SORT_DESCENDING = 'sortdescending'
export const DELETE_SCHOOL   = 'deleteschool'
export const SEARCH_SCHOOLS  = 'searchschools'
export const RESET_SCHOOLS   = 'resetschools'
export const SEARCHING_SCHOOL = 'searchingschools'
// season settings
export const FETCH_SEASON_RANKINGS       = 'fetchseasonrankings'
export const FETCH_AVAILABLE_RANKINGS    = 'fetchavailablerankings'
export const FETCH_SEASON_WEEKS          = 'fetchseasonweeks'
export const FETCH_EVENT                 = 'fetchevent'
export const FETCHING_EVENT              = 'fetchingevent'
export const FETCH_ACTIVE_SEASONS        = 'fetchactiveseasons'
export const FETCH_ALL_SEASONS           = 'fetchallseasons'
export const FETCH_SEASON_DATES          = 'fetchseasondates'
export const SAVE_SEASON_DATES           = 'saveseasondates'
export const SAVE_SEASON_OILCONDITIONS   = 'saveseasonoilconditions'
export const SAVE_SEASON_SETUP           = 'saveseasonsetup'
export const SAVE_SEASON_PARTICIPANT     = 'saveseasonparticipant'
export const SAVING_PARTICIPANT_INFO     = 'savingseasonparticipant'
export const SAVE_SEASON_TEMPLATE        = 'saveseasontemplate'
export const SAVE_SEASON_RANKING         = 'saveseasonranking'
export const TRIGGER_SEASON              = 'triggerseason'
export const SAVE_SEASON_RANKINGPOINTS   = 'seasonrankingpoints'
export const RESET_DATES_SETTINGS        = 'resetdatessettings'
export const RESET_SETUP_SETTINGS        = 'resetsetupsettings'
export const RESET_OIL_SETTINGS          = 'resetoilsettings'
export const RESET_PARTICIPANT_SETTINGS  = 'resetparticipantsettings'
export const RESET_TEMPLATE_SETTINGS     = 'resettemplatesettings'
export const DELETE_EVENT                = 'deleteevent'
export const ENABLE_UPLOAD               =  'enableupload'
export const COPY_EVENT                  = 'copyevent'
export const NOTIFY_SCHOOL_NOT_FOUND     = 'schoolnotfound'
export const NOTIFY_SCHOOL_NOT_FOUND_KNOWLEDGMENT =  'schoolnotfoundknowlegment'
export const RESEND_DIRECTOR_EMAIL       = 'RESEND_DIRECTOR_EMAIL'
export const RESENDING_DIRECTOR_EMAIL    = 'resendingdirectoremail'
export const SET_EVENT_SPONSOR           = 'seteventsponsor'
export const SAVE_EVENT_CERT_NUMBER      = 'saveeventcertificationnumber'
export const SET_WIZARD_STEP             = 'setwizardstep'
export const RESET_RANKING_POINTS_SETTINGS  = 'resetrankingpointsfile'
export const SAVING_SEASON_RANKING          = 'savingseasonrankings'
export const SET_RANKINGPOINTS_FILE         = 'setrankingpointsfile'
export const FETCH_SEASON_RANKING_POINTS    = 'fetchseasonrankingpoints'
export const GETTING_SEASON_RANKING_POINTS  = 'gettingseasonrankingpoints'
export const FETCH_COMPLETED_EVENTS         = 'fetchcompletedevents'
export const GETTING_PARTICIPANT_ROSTER     = 'gettingparticipantroster'
export const RESET_RETRIEVED_EVENT          = 'resetretrievedevent'
export const SET_CERTIFICATION_NUMBER       = 'setCertNumber'
export const SET_SELECTED_SCHOOL            = 'setselectedschool'
export const SET_USER_ROLE                  = 'setuserrole'
export const SET_CORRECT_EVENT_INFO         = 'setcorrecteventinfo'
export const SET_CORRECT_EVENT_DETAILS      = 'setcorrecteventdetails'
export const RUN_SEASON_RANKINGS            = 'runseasonrankings'
export const SET_EVENT_JV                   = 'seteventjv'
export const UPDATE_EVENT_JV                = 'updateventjv'
export const SET_HAS_BRACKETS               = 'sethasbrackets'
export const REFRESH_PARTICIPANT_ROSTER     = 'refreshparticipantroster'
export const RESET_EVENT_WIZARD = 'reseteventwizard'
export const PUBLISH_RANKINGS = 'publishrankings'
export const fileUpload = {
    UPLOAD_EVENT_RESULTS: 'uploadeventresults',
    SET_EVENT_RESULTS_FILENAME: 'seteventresultsfilename',
    RESET_EVENT_RESULTS_FILE: 'reseteventresultsfile',
    UPLOADING_RESULTS_FILE: 'uploadingresultsfile',
    WRONG_FILE_UPLOAD_TYPE: 'wrongfileuploadtype',
    RESET_UPLOAD_ERROR_MESSAGE:'resetuploaderrormessage'
}
export const user = {
    CHECK_USER_ROLE: '/user/inrole/rolename',    
    GET_USER_ROLE: '/user/inrole/rolename',
    SET_USER_ROLE:'user/setrole',
    CHECKING_USER_ROLE:'user/CHECKING_USERROLE'    
}


// WEBPACK FOOTER //
// ./src/redux/actions/index.js